<template>
  <div class="customkc-wrap">
    <div
      class="customkc-bg"
      :style="'height:'+bgh"
    >
      <slot name="customkcIndex"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgh: {
      type: String,
      default: "777px"
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>


// WEBPACK FOOTER //
// src/components/customkc/index.vue